import BaseComponent from './BaseComponent';
// import Swiper        from 'swiper';
import { throttle }  from 'lodash';

class SliderHeader extends BaseComponent {
  constructor(componentName){
    super(componentName);

    this.options = {
      wrapperClass: 'slides-list',
      slideClass: 'slide',
      simulateTouch: false,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: '.slider_header__btn--prev',
        nextEl: '.slider_header__btn--next'
      },
      pagination: {
        el: '.slider__pagination',
        clickable: true,
      },
      grabCursor: true,
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      // effect: 'fade',
      // fadeEffect: {
      //   crossFade: true
      // },
      watchOverflow: true,
      on: {
        init: function () {
          // console.log('swiper initialized');
        }
      }
    };
    this.classElement = `.${componentName}`;
  }


  init(component) {
    let slidesAmount;
    if(!!component) {
      slidesAmount = component.element.getElementsByClassName('slide').length;
    } else {
      const header = document.getElementsByTagName('header')[0];
      slidesAmount = !!header ? header.getElementsByClassName('slide').length : null;
    }

    if (slidesAmount > 1) {
      this.slider = new Swiper(this.classElement, this.options);
      // and  if slide contains slide--video then this.options.autoplay none
    }

    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    const links = component.element.getElementsByClassName('slide--link');

    for (let link of links) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.gtmPromotionClick(link);
      });
    }
  }

  gtmPromotionClick(promotion) {
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      'event': 'promotionClick',
      'ecommerce': {
        'promoClick': {
          'promotions': [{
            'name'     : promotion.getAttribute('data-gtm-name'),
            'id'       : promotion.getAttribute('data-gtm-id'),
            'position' : promotion.getAttribute('data-gtm-position')
          }]
        }
      },
      'eventCallback': function() {
        document.location = promotion.href;
      }
    });
  }

  update() {
    this.init();
  }

}

export default SliderHeader;
